import { smoothScroll } from '../../utils/smoothScroll';
import doctorImage from '../../assets/draramirez.jpg';
import './Hero.css';

const Hero = () => {
    const handleScroll = (e, targetId) => {
        e.preventDefault();
        smoothScroll(targetId);
    };

    return (
        <section id="home" className="hero-section">
            <div className="hero-container">
                <div className="hero-image-container">
                    <img src={doctorImage} alt="Dra. Walquiria Ramirez" className="hero-image" />
                </div>
                <div className="hero-content">
                    <h1>Dra. Walquiria Ramirez</h1>
                    <p className="hero-subtitle">Médica Clínica</p>
                    <p className="hero-text">Atención médica enfocada en la prevención, el diagnóstico y el tratamiento integral del adulto en Tandil.</p>
                    <div className="hero-actions">
                        <a href="#booking" onClick={(e) => handleScroll(e, '#booking')} className="btn-primary">Pedir Turno</a>
                        <a href="#consult" onClick={(e) => handleScroll(e, '#consult')} className="btn-secondary">Conocé más</a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
